<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
  >
    <el-row>
      <el-col :span="12"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px">
            <span style="color: red; margin-right: 5px">*</span>
            <label for="">课件名称：</label>
            <el-input
              v-model="name"
              placeholder="请输入"
              style="width: 80%"
              :disabled="ifDisabled"
            ></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="type == 1">
        <div class="grid-content bg-purple-dark" style="margin-top: 20px">
          <div style="font-size: 12px">
            <el-checkbox v-model="continuousInput">连续录入</el-checkbox>
          </div>
        </div>
      </el-col>
      <!--        <el-col :span="12"><div class="grid-content bg-purple-dark">-->
      <!--          <div style="font-size: 12px;">-->
      <!--            <span style="color: red;margin-right: 5px;">*</span>-->
      <!--            <label for="">课件代码：</label>-->
      <!--            <el-input v-model="code" placeholder="请输入" style="width: 80%;"></el-input>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        </el-col>-->
    </el-row>
    <el-row>
      <el-col :span="12"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px">
            <span style="color: red; margin-right: 5px; visibility: hidden"
              >*</span
            >
            <label for="">课件类别：</label>
            <el-select v-model="kcType" placeholder="请选择" style="width: 80%">
              <el-option
                v-for="item in courseType"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
      <el-col :span="12"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px; position: relative">
            <span style="color: red; margin-right: 5px">*</span>
            <label for="">讲课老师：</label>
            <el-select
              v-model="teacher"
              placeholder="请选择"
              @clear="selectClearTeacher"
              @change="selectChangeTeacher"
              @blur="selectBlurTeacher"
              @focus="focusSelectTeacher"
              clearable
              filterable
              style="width: 80%"
              :disabled="userType === '3'"
            >
              <el-option
                v-for="item in teacherList"
                :key="item.uid"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px">
            <span style="color: red; margin-right: 5px; visibility: hidden"
              >*</span
            >
            <label for="">知识点：</label>
            <template>
              <el-select
                v-model="knowLeg"
                placeholder="请选择"
                @clear="selectClear"
                @change="selectChange"
                @blur="selectBlur"
                clearable
                filterable
                style="width: 80%"
              >
                <el-option
                  v-for="item in knowLegList"
                  :key="item.id"
                  :label="item.knowledgeName"
                  :value="item.id"
                >
                </el-option>
                <!-- <div
                  @click="moreKnowled"
                  v-show="more"
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #ccc;
                    padding: 5px 0;
                    cursor: pointer;
                  "
                >
                  点击更多
                </div> -->
              </el-select>
            </template>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px">
            <span style="color: red; margin-right: 5px">*</span>
            <label for="">上传人：</label>
            <el-input
              v-model="uploadUser"
              :disabled="true"
              style="width: 80%"
            ></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="12"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px">
            <span style="color: red; margin-right: 5px">*</span>
            <label for="">上传时间：</label>
            <el-date-picker
              v-model="datetime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px; line-height: 40px">
            <span style="color: red; margin-right: 5px">*</span>
            <label for="" style="vertical-align: top">推送机构：</label>
            <el-radio-group
              v-model="organ"
              @change="organChange"
              v-show="chooseType"
            >
              <el-radio :label="1">{{ institutionCur }}</el-radio>
              <el-radio :label="2">推送所有机构</el-radio>
              <el-radio :label="3">选择推送机构</el-radio>
            </el-radio-group>
            <div
              style="
                line-height: 40px;
                display: inline-block;
                width: 90%;
                vertical-align: top;
              "
              v-show="hadChoose"
            >
              <span v-for="(o, index) in hadChooseList" :key="index"
                >{{ o.title }}|</span
              >
              <el-button
                type="primary"
                style="margin-left: 30px"
                @click="changeAgain"
                >重新选择</el-button
              >
            </div>
            <div v-show="moreOrgan">
              <el-checkbox-group
                v-model="chooseOrgan"
                style="padding: 0 60px; line-height: 30px"
              >
                <el-checkbox
                  v-for="(organs, index) in organList"
                  :key="index"
                  :value="organs.id"
                  :label="organs"
                  >{{ organs.title }}</el-checkbox
                >
              </el-checkbox-group>
              <el-button
                type="primary"
                style="margin: 10px auto 0; display: block"
                @click="getOrganList"
                >确 定</el-button
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px">
            <span style="color: red; margin-right: 5px; visibility: hidden"
              >*</span
            >
            <label for="">课件类型：</label>
            <template>
              <el-radio-group v-model="kjType" @change="chooseFileType">
                <el-radio :label="1">视频</el-radio>
                <el-radio :label="2">音频</el-radio>
                <el-radio :label="3">文本</el-radio>
                <el-radio :label="4">文档</el-radio>
                <el-radio :label="5">音视频链接</el-radio>
              </el-radio-group>
              <el-input
                v-model="links"
                v-show="linkShow"
                style="width: 80%; margin-left: 70px; margin-top: 10px"
                placeholder="请输入音视频链接"
              ></el-input>
            </template>
            <el-upload
              v-show="uploadShow"
              class="upload-demo"
              :action="url + '/zkfz/file/addUploadFile'"
              :before-upload="beforeUpload"
              :on-change="handleChange"
              :on-remove="removeFile"
              :on-success="successUpload"
              :on-error="errorUp"
              :file-list="fileList"
            >
              <el-button
                size="small"
                type="primary"
                style="margin-left: 70px; margin-top: 10px"
                >点击上传</el-button
              >
            </el-upload>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"
        ><div class="grid-content bg-purple-dark">
          <div style="font-size: 12px" v-show="ifDurations">
            <span style="color: red; margin-right: 5px">*</span>
            <label for="">时长： </label>
            <el-time-picker
              :disabled="kjType != '5' || type == '2'"
              v-model="duration"
              value-format="HH:mm:ss"
              format="HH:mm:ss"
              :picker-options="{}"
              placeholder="请选择上传"
            >
            </el-time-picker>
            <!--            <el-input v-model="duration" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字" style="width: 50%;"></el-input>-->
          </div>
        </div>
      </el-col>
      <el-col :span="12" :push="11">
        <div class="continuous_input" v-show="isVideo" @click="handlePreview">
          预览
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="16" :push="4">
        <div
          class="preview_video"
          v-show="isShowVideo"
          @click.prevent="handleVideo"
        >
          <div class="mask" v-show="isShowMask"></div>
          <video
            ref="video"
            :src="videoSrc"
            style="width: 100%"
            preload
            controls
          ></video>
        </div>
      </el-col>
    </el-row>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: inline-block; width: 100%; text-align: center"
    >
      <el-button type="primary" @click="pass">保 存</el-button>
      <el-button type="" @click="handleClose">返 回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
let durations = ''
export default {
  name: 'CoursewareManagerAdd',
  components: {},
  inject: ['reload'],
  props: ['courseWareId'],
  data() {
    return {
      ifDurations: true,
      duration: '',
      ifDisabled: false,
      isChange: true,
      links: '',
      more: true,
      linkShow: false,
      uploadShow: true,
      chooseType: true,
      fileList: [],
      name: '英语课件',
      continuousInput: true,
      code: 'xx-bb',
      kcType: '',
      organ: '',
      chooseOrgan: [],
      organList: [],
      hadChooseList: [],
      moreOrgan: false,
      hadChoose: false,
      uploadUser: '',
      updateTime: '2020-10-10',
      updateUser: 'xx',
      updateNum: '0',
      status: '审核中',
      cites: '0',
      kjType: '',
      filesName: 'xxx.mp4',
      pushCompany: '百度',
      datetime: '2020-10-10',
      title: '添加课件',
      dialogVisible: false,
      loading: false,
      courseType: [],
      teacher: '',
      teacherList: [],
      knowLeg: '',
      knowLegList: [],
      clickNum: 0,
      institutionId: '',
      insIds: '',
      file: '',
      fileId: '',
      type: '',
      id: '',
      institutionCur: '',
      isWriter: true,
      isUpload: true,
      isVideo: false,
      isShowVideo: false,
      isShowMask: true,
      isPlay: false,
      videoSrc: '',
      userType: '',
      oldKnowleg: '',
      knowledgeId: '',
    }
  },
  methods: {
    selectBlur(e) {
      // 意见类型
      if (e.target.value !== '') {
        console.log(e.target.value)
        this.knowLeg = e.target.value
        this.$forceUpdate() // 强制更新
      }
    },

    selectClear() {
      this.knowLeg = ''
      this.$forceUpdate()
    },
    selectChange(val) {
      console.log(val)
      this.knowLeg = val
      this.$forceUpdate()
    },

    chooseFileType() {
      this.fileList = []
      if (this.kjType == '5') {
        this.uploadShow = false
        this.linkShow = true
        this.ifDurations = true
      } else {
        this.uploadShow = true
        this.linkShow = false
        this.ifDurations = true
        this.isVideo = false
        if (this.kjType == '1') {
          this.isVideo = true
        }
        if (this.kjType == '3' || this.kjType == '4') {
          this.ifDurations = false
        }
      }
    },
    async beforeUpload(file) {
      this.isUpload = false
      if (this.kjType == '1') {
        //视频
        const isJPG = file.type === 'video/mp4'
        const isLt2M = file.size / 1024 / 1024 < 1024 * 3 //3G
        console.log(file.type)

        if (!isJPG) {
          this.$message.error('上传文件只能是 mp4 类型!')
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 3G!')
        }
        if (isJPG && isLt2M) {
          this.isUpload = true
          this.getDuration(file)
        }
        return isJPG && isLt2M
      } else if (this.kjType == '2') {
        //音频
        const isJPG = file.type === 'audio/mpeg'
        const isLt2M = file.size / 1024 / 1024 < 1024
        console.log(file.type)

        if (!isJPG) {
          this.$message.error('上传文件只能是 mp3 类型!')
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 1G!')
        }
        if (isJPG && isLt2M) {
          this.isUpload = true
          this.getDuration(file)
        }
        return isJPG && isLt2M
      } else if (this.kjType == '4') {
        //文档
        const isJPG = file.type == 'application/pdf'
        const isLt2M = file.size / 1024 / 1024 < 1024
        console.log(file.type)
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 1G!')
          return false
        }
        if (!isJPG) {
          this.$message.error('上传文件只能是pdf类型!')
          return false
        }
        this.isUpload = true
        return isLt2M && isJPG
      } else if (this.kjType == '3') {
        //文本
        const isJPG = file.type === 'text/plain'
        const isLt2M = file.size / 1024 / 1024 < 1024
        console.log(file.type)

        if (!isJPG) {
          return this.$message.error('上传文件只能是 txt 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 1G!')
        }
        this.isUpload = true
        return isJPG && isLt2M
      }
    },

    organChange(val) {
      if (val == 3) {
        this.moreOrgan = true
      } else if (val == 1) {
        this.moreOrgan = false
        this.hadChooseList = []
        this.chooseOrgan = []
        this.institutionId = this.institutionId
      } else if (val == 2) {
        this.moreOrgan = false
        this.hadChooseList = []
        this.chooseOrgan = []
        this.institutionId = 'all'
      }
    },

    getOrganList() {
      this.hadChooseList = []
      this.chooseType = false
      this.hadChoose = true
      this.moreOrgan = false
      this.hadChooseList = this.chooseOrgan
      console.log(this.hadChooseList)
      this.institutionId = ''
      for (let i = 0; i < this.chooseOrgan.length; i++) {
        this.institutionId += this.chooseOrgan[i].id + ','
        console.log(this.institutionId)
      }
    },

    changeAgain() {
      this.chooseOrgan = []
      this.chooseType = true
      this.hadChoose = false
      this.moreOrgan = true
      this.organ = 3
    },

    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.file = file.raw
    },
    removeFile() {
      this.isUpload = false
      this.videoSrc = ''
      this.isShowVideo = false
      this.duration = ''
    },
    successUpload(res, file, fileList) {
      console.log(this.isUpload)
      let formdata = new FormData()
      formdata.append('file', file.raw)
      if (res.code === 100000) {
        this.fileId = res.data
        // console.log(this.fileId, 'this.fileId')
        api.beforeSaveUpload(res.data).then(({ data }) => {
          this.videoSrc = data.data.url
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    errorUp(err, file, fileList) {
      this.isUpload = false
      return this.$message.error(err)
    },
    // 时分秒转秒
    toS(time) {
      let times = time.split(':')
      let second = times.length > 0 ? parseInt(times.pop()) : 0
      if (second >= 60) throw Error('格式不正确')
      let minute = times.length > 0 ? parseInt(times.pop()) : 0
      if (minute >= 60) throw Error('格式不正确')
      let hour = times.length > 0 ? parseInt(times.pop()) : 0
      if (hour >= 24) throw Error('格式不正确')

      let secondCount = hour * 3600
      secondCount += minute * 60
      secondCount += second
      return secondCount
    },

    pass() {
      if (this.kjType == '5') {
        if (this.links === '') {
          return this.$message.error('请填写音视频链接')
        }
      }
      if (!this.isUpload) return this.$message.error('请上传正确的文件后保存')
      const isOptions = this.teacherList.some(
        (item) => item.name === this.teacher
      )
      if (!isOptions) {
        console.log(12312321)
        return this.$message.error('请选择下拉框中的讲师')
      }
      if (
        this.name.trim() == ' ' ||
        this.name == null ||
        this.name == undefined ||
        this.name.trim() == ''
      ) {
        this.$message({ type: 'warning', message: '请完善必填信息' })
        return
      } else if (
        this.teacher.trim() == ' ' ||
        this.teacher == null ||
        this.teacher == undefined ||
        this.teacher.trim() == ''
      ) {
        this.$message({ type: 'warning', message: '请完善必填信息' })
        return
      } else if (
        this.uploadUser == ' ' ||
        this.uploadUser == null ||
        this.uploadUser == undefined
      ) {
        this.$message({ type: 'warning', message: '请完善必填信息' })
        return
      } else if (
        this.datetime == ' ' ||
        this.datetime == null ||
        this.datetime == undefined
      ) {
        this.$message({ type: 'warning', message: '请完善必填信息' })
        return
      } else {
        if (this.organ == '3') {
          if (this.hadChooseList.length == 0) {
            this.$message({ type: 'warning', message: '请完善必填信息' })
            return
          } else {
          }
        }

        if (this.kjType == '1' || this.kjType == '2' || this.kjType == '5') {
          if (!this.duration) {
            this.$message({ type: 'warning', message: '请完善必填信息' })
            return
          }
        }

        let formdata = new FormData()
        if (this.type == 2) {
          //编辑
          formdata.append('duration', this.toS(this.duration))
          formdata.append('id', this.id)
          formdata.append('uid', this.getUId)
          formdata.append('title', this.name)
          formdata.append('courseWareType', this.kcType)
          formdata.append('teacherName', this.teacher)
          if (this.knowLeg === this.oldKnowleg) {
            this.knowLeg = this.knowledgeId
          }
          formdata.append('knowledgeId', this.knowLeg)
          console.log(this.knowLeg + '22222222222222222')
          formdata.append('institutionId', this.institutionId)
          if (
            this.kjType == '' ||
            this.kjType == null ||
            this.kjType == undefined
          ) {
          } else {
            formdata.append('type', this.kjType)
          }

          formdata.append('wareStatus ', '0')
          formdata.append(
            'ctime',
            Math.round(new Date(this.datetime).getTime() / 1000).toString()
          )
          if (this.kjType == '5') {
            formdata.append('videoAddress', this.links)
          } else {
            // formdata.append('file', this.file)
            formdata.append('fileId', this.fileId)
            console.log(this.file)
          }
        } else if (this.type == 1) {
          //新增
          formdata.append('duration', this.toS(this.duration))
          formdata.append('uid', this.getUId)
          formdata.append('title', this.name)
          formdata.append('courseWareType', this.kcType)
          formdata.append('teacherName', this.teacher)
          formdata.append('knowledgeId', this.knowLeg)
          formdata.append('institutionId', this.institutionId)
          formdata.append('type', this.kjType)
          const courseWareId = this.courseWareId || this.$route.query.id
          formdata.append('courseWareId', courseWareId)
          formdata.append(
            'ctime',
            Math.round(new Date(this.datetime).getTime() / 1000).toString()
          )
          if (this.kjType == '5') {
            formdata.append('videoAddress', this.links)
          } else {
            // formdata.append('file', this.file)
            formdata.append('fileId', this.fileId)
          }
        }
        api.addCourse(formdata).then(({ data }) => {
          if (data.code == 100000) {
            data = data.data
            console.log(data)
            this.$message({ type: 'success', message: '保存成功' })
            if (this.continuousInput) {
              this.name = ''
              this.knowLeg = ''
              // this.kjType = ''
              this.duration = ''
              this.links = ''
              this.videoSrc = ''
              this.isVideo = false
              this.isShowVideo = false
              this.fileList.splice(0, 1)
            } else {
              this.$emit('closeAddCourse')
              this.dialogVisible = false
            }
          } else {
            this.$message({ type: 'error', message: data.msg })
          }
        })
      }
    },

    // 秒转时分秒
    secondsFormat(value) {
      console.log(22)
      let h =
        Math.floor(value / 3600) < 10
          ? '0' + Math.floor(value / 3600)
          : Math.floor(value / 3600)
      let m =
        Math.floor((value / 60) % 60) < 10
          ? '0' + Math.floor((value / 60) % 60)
          : Math.floor((value / 60) % 60)
      let s =
        Math.floor(value % 60) < 10
          ? '0' + Math.floor(value % 60)
          : Math.floor(value % 60)
      return (value = h + ':' + m + ':' + s)
    },

    // 初始化
    init(type, id) {
      this.getSchoolByUid()
      this.dialogVisible = true
      this.type = type
      console.log(this.type + '---------------------')
      this.id = id
      if (this.type == 2) {
        //编辑
        this.title = '修改课件'
        this.fileList = []
        this.chooseType = false
        this.hadChoose = true
        this.ifDisabled = true
        this.hadChooseList = []
        this.linkShow = false
        this.links = ''
        this.uploadShow = true
        this.continuousInput = false
        const courseWareId = this.courseWareId || this.$route.query.id
        api.getDetail({ id: this.id, courseWareId }).then(({ data }) => {
          data = data.data
          console.log(data)
          this.name = data.title
          this.duration = this.secondsFormat(data.duration)
          this.kcType = data.courseWareType
          this.teacher = data.teacherName
          if (this.userType === '3') {
            this.teacher = this.uploadUser
          }
          this.knowLeg = data.knowledgeName //由于分页请求回来的数据中id无法匹配到对应的名字
          this.oldKnowleg = data.knowledgeName //保留初始值来对比
          this.knowledgeId = data.knowledgeId //如果没有改动知识点,利用这个id重新赋值
          console.log(this.knowLeg + '111111111111111111')
          this.uploadUser = data.uname
          this.status = data.wareStatus
          this.updateTime = data.updateTime
          this.updateNum = data.updateCount
          this.kjType = data.type
          this.updateId = data.updateId
          if (data.type == '1') {
            this.isVideo = true
            this.videoSrc = data.url
          }
          if (data.type == '1' || data.type == '2' || data.type == '5') {
            this.ifDurations = true
          }
          if (data.type == '5') {
            this.linkShow = true
            this.links = data.videoAddress
            this.uploadShow = false
          } else {
            this.linkShow = false
            this.links = ''
            this.uploadShow = true
          }
          if (
            data.fileName != '' &&
            data.fileName != null &&
            data.fileName != undefined
          ) {
            this.fileList.push({ name: data.fileName, url: data.url })
          }
          this.datetime = this.formatDate2(data.ctime)
          this.institutionId = ''
          for (let i = 0; i < data.list.length; i++) {
            if (data.list[i].checked == '1') {
              this.hadChooseList.push(data.list[i])
              this.institutionId += data.list[i].id + ','
            }
            this.chooseOrgan = this.hadChooseList
          }
          console.log(this.chooseOrgan)
          console.log(this.institutionId)
        })
      } else {
        //添加
        this.title = '添加课件'
        this.currentTime()
        this.organ = 1
        this.kjType = 1
        this.isVideo = true
      }
    },

    // 时间戳转日期
    formatDate2(cellValue) {
      if (cellValue == null || cellValue == '') return ''
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    getDuration(file) {
      var binaryData = []
      // 传入file
      binaryData.push(file)
      //获取视频或者音频时长
      var fileurl = URL.createObjectURL(
        new Blob(binaryData, { type: 'application/zip' })
      )
      //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(fileurl)
      var duration = ''
      audioElement.addEventListener('loadedmetadata', (_event) => {
        duration = audioElement.duration
        console.log('播放时长:' + duration)
        this.duration = this.times(duration)
      })
      return duration
    },
    times(data) {
      var time = Number(data)
      var h = Math.floor(time / 3600)
      var m = Math.floor((time % 3600) / 60)
      var s = parseInt(time % 3600) % 60
      var hh = h < 10 ? '0' + h : h
      var mm = m < 10 ? '0' + m : m
      var ss = s < 10 ? '0' + s : s
      return hh + ':' + mm + ':' + ss
    },
    // 获取数据
    getList() {
      //      this.loading = true
      this.name = ' '
      this.code = ' '
      this.teacher = ' '
      // this.uploadUser = ' '
      // this.datetime = ' '
      this.organ = ' '
      this.hadChooseList = []
    },

    handleClose() {
      this.$emit('closeAddCourse')
      this.dialogVisible = false
    },

    // 获取类别
    getTypeList() {
      api.getList({ page: 1, pageSize: 100 }).then(({ data }) => {
        data = data.data
        console.log(data)
        this.courseType = data.list
      })
    },

    knowledgeGetList() {
      // this.clickNum++
      // let page = this.clickNum * 1
      const courseWareId = this.courseWareId || this.$route.query.id
      api
        .knowledgeGetList({
          page: 1,
          // pageSize: '10',
          courseWareId,
        })
        .then(({ data }) => {
          data = data.data
          // if (data.total < 10) {
          //   this.more = false
          // }
          // if (this.clickNum * 10 > data.total) {
          //   this.more = false
          // }
          // for (let i = 0; i < data.list.length; i++) {
          //   this.knowLegList.push(data.list[i])
          // }
          this.knowLegList = data.list.map((item) => {
            return { knowledgeName: item.knowledgeName, id: item.id }
          })
        })
    },
    moreKnowled() {
      this.knowledgeGetList()
    },

    // 获取机构列表
    getinstitutionList() {
      api.getinstitutionList().then(({ data }) => {
        data = data.data
        console.log(data)
        this.organList = data.list
      })
    },
    // 获取当前机构
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        console.log(data)
        this.institutionId = data.data.id
        this.institutionCur = data.data.title
        this.getTeacherList()
      })
    },
    // 获取当前用户
    getUserByUid() {
      api.getUserByUid(this.getUId).then(({ data }) => {
        console.log(data)
        this.userType = data.data.type
        this.uploadUser = data.data.uname
      })
    },

    formatDate: function (value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    },
    // 获取当前时间
    getTime: function () {
      let _this = this
      let yy = new Date().getFullYear()
      let mm =
        new Date().getMonth() < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
      let dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      let ss =
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
      _this.datetime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
    },
    currentTime() {
      setInterval(this.getTime, 500)
    },
    handlePreview() {
      this.isShowVideo = !this.isShowVideo
    },
    handleVideo() {
      if (this.isPlay) {
        this.isShowMask = true
        this.$refs.video.pause()
        this.isPlay = false
      } else {
        this.isShowMask = false
        this.$refs.video.play()
        this.isPlay = true
      }
    },
    handlePlay() {
      this.isPlay = true
      this.isShowMask = false
    },
    handlePause() {
      this.isPlay = false
      this.isShowMask = true
    },
    getTeacherList() {
      const name = ''
      const mhmId = this.institutionId
      api.getTeacher({ name, mhmId }).then(({ data }) => {
        if (data.code === 100000) {
          this.teacherList = data.data.map((item) => {
            return { uid: item.uid, name: item.name || '未命名' }
          })
        }
      })
    },
    selectClearTeacher() {
      this.teacher = ''
    },
    selectChangeTeacher(val) {
      this.teacher = val
    },
    selectBlurTeacher(e) {
      if (e.target.value !== '') {
        this.teacher = e.target.value
      }
    },
    focusSelectTeacher() {
      if (this.teacher.trim() === '') {
        this.teacher = ''
      }
    },
  },
  created() {
    this.getList()
    this.getTypeList()
    this.knowledgeGetList()
    this.getinstitutionList()
    this.getUserByUid()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  watch: {
    isShowVideo() {
      if (this.isShowVideo) {
        this.$refs.video.addEventListener('play', this.handlePlay)
        this.$refs.video.addEventListener('pause', this.handlePause)
      } else {
        this.$refs.video.removeEventListener('play', this.handlePlay)
        this.$refs.video.removeEventListener('pause', this.handlePause)
      }
    },
    userType() {
      if (this.userType === '3') {
        this.teacher = this.uploadUser
      }
    },
    kcType(val) {
      const index = this.courseType.findIndex((item) => item.id === val)
      if (index < 0) {
        this.kcType = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
.continuous_input {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 70px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background-color: #529fff;
  border-radius: 4px;
  cursor: pointer;
}
.preview_video {
  position: relative;
  .mask {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    content: '';
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-left: 60px solid #000;
    border-bottom: 30px solid transparent;
    z-index: 6;
  }
}

// video::shadow #clickToPlay {
//   display: none !important;
//   -webkit-appearance: none;
// }

*::-webkit-media-controls-overlay-play-button {
  display: none !important;
  -webkit-appearance: none;
}
.teacherList {
  position: absolute;
  z-index: 6;
  left: 13%;
  width: 80.5%;
  height: 200px;
  overflow-y: auto;
  .teacherItem {
    margin-bottom: 12px;
    cursor: pointer;
  }
}
</style>
<style>
.grid-content {
  min-height: 20px;
  line-height: 20px;
  margin: 10px 0;
}
</style>
